/**
 * Created with IntelliJ IDEA.
 * User: Aaron Adams
 * Date: 25.10.12
 * Time: 10:25
 * To change this template use File | Settings | File Templates.
 */

/**
 * This class is for country specific configurations
 */
export class BasicLocalizationData {
    private _usernameMinLength: number;

    public get getUsernameMinLength(): number {
        return this._usernameMinLength;
    }

    public set setUsernameMinLength(value: number) {
        this._usernameMinLength = value;
    }
}
